@if (isToggleNotificationsVisible()) {
<av-tooltip position="left" [enabled]="!isOpen()">
  <button
    #toggleBtn
    [attr.aria-label]="
      (isOpen() ? 'Close' : 'Open') + ' notifications' | translate
    "
    avButton
    class="notification-toggle"
    ofType="icon"
    size="xs"
    [@slideFromRight]="true"
    color="basic"
    [raised]="true"
    (click)="toggle()"
  >
    @if (!isOpen()) {
    <av-icon name="bell"></av-icon>
    } @if (isOpen()) {
    <av-icon name="arrow-right"></av-icon>
    }
  </button>
  @if (!isOpen()) {
  <span
    [attr.aria-label]="
      notifications().length + ' ' + ('unread notification(s)' | translate)
    "
    class="notification-counter"
    [class.notification-counter-small]="isWidget"
  >
    @if (!isWidget) {
    {{ notifications().length }}
    }
  </span>
  }
  <ng-container tooltipMessage>
    <!-- {{ notifications().length }}
      <span *ngIf="notifications().length === 1" translate>{{
        "notification" | translate
      }}</span>
      <span *ngIf="notifications().length > 1" translate>{{
        "notifications" | translate
      }}</span> -->
    {{ "notifications" | translate }}
  </ng-container>
</av-tooltip>
} @if(isOpen()){
<div
  #notificationList
  role="region"
  [attr.aria-label]="'Notifications' | translate"
  class="fx-column fx-gap-sm"
>
  @for (n of notifications(); track trackByFn($index, n)) {
  <app-notification
    [@slideFromRight]="true"
    (removed)="remove($event)"
    [notification]="n"
    [notificationIndex]="i"
    [notificationsTotal]="notifications().length"
  >
  </app-notification>
  }
</div>
}
